(() => {
  'use strict';
  if (window.LymiaUFO) return;
  const loader = document.querySelector('script[data-ufo-bootstrap]');
  const dialog = document.querySelector('#lymia-ufo-dialog');
  const petal = document.querySelector('[data-ufo-petal]');
  if (!loader || !dialog || !petal) return;
  const $ = (selector) => dialog.querySelector(selector);
  const canvas = $('[data-ufo-canvas]');
  const status = $('[data-ufo-status]');
  const result = $('[data-ufo-result]');
  const timer = $('[data-ufo-timer]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const names = {
    'star-gold': 'Fragment doré', 'star-rose': 'Fragment rose',
    'star-mint': 'Fragment menthe', 'star-sky': 'Fragment bleu ciel',
    'star-lilac': 'Fragment lilas', 'star-peach': 'Fragment pêche',
    'star-ice': 'Fragment de glace', 'star-coral': 'Fragment corail',
  };
  const collection = Object.fromEntries(Object.keys(names).map((kind) => [kind, 0]));
  // The former souvenir collection stays stored separately from the stars.
  const collectionKey = 'lymia-ufo-stars-v1';
  try {
    const saved = JSON.parse(localStorage.getItem(collectionKey));
    for (const kind of Object.keys(names)) if (Number.isSafeInteger(saved?.[kind]) && saved[kind] >= 0) collection[kind] = Math.min(9999, saved[kind]);
  } catch (_) { /* Optional local collection. */ }
  let game = null, scene = null, loading = null, phase = '';
  let frame = null, lastTime = null, contextLost = false, suspended = false;
  let returnFocus = null, oldOverflow = '';
  const held = { x: false, z: false };
  let nextPetal = 35 + Math.random() * 30;
  let petalState = null, petalFrame = null, petalTime = null, petalHovered = false;

  const showCollection = () => {
    for (const kind of Object.keys(names)) {
      const item = $(`[data-ufo-kind="${kind}"]`);
      if (!item) continue;
      item.querySelector('[data-ufo-count]').textContent = String(collection[kind]);
      item.classList.toggle('is-collected', collection[kind] > 0);
    }
  };
  showCollection();
  const setStatus = (message = '') => {
    status.textContent = message;
    status.hidden = !message;
  };
  const loadScript = (url) => new Promise((resolve, reject) => {
    if (!url) return reject(new Error('Asset UFO manquant'));
    const script = document.createElement('script');
    const timeout = setTimeout(() => { script.remove(); reject(new Error('Chargement trop long')); }, 30000);
    script.src = url;
    script.onload = () => { clearTimeout(timeout); resolve(); };
    script.onerror = () => { clearTimeout(timeout); script.remove(); reject(new Error('Asset UFO indisponible')); };
    document.head.appendChild(script);
  });
  const enableControls = () => {
    const playable = !!game && !contextLost;
    $('[data-ufo-start]').disabled = !playable || phase !== 'idle';
    $('[data-ufo-right]').disabled = !playable || phase !== 'aim-x';
    $('[data-ufo-back]').disabled = !playable || phase !== 'aim-z';
    $('[data-ufo-drop]').disabled = !playable || phase !== 'ready-drop';
    $('[data-ufo-view-reset]').disabled = !scene || contextLost;
  };
  const setPhase = (next) => {
    if (next === phase) return;
    phase = next;
    held.x = held.z = false;
    $('[data-ufo-right]').setAttribute('aria-pressed','false');
    $('[data-ufo-back]').setAttribute('aria-pressed','false');
    dialog.setAttribute('data-ufo-phase', next);
    if (!contextLost) setStatus();
    if (next === 'aim-x') { result.hidden=true; result.textContent=''; }
    enableControls();
  };
  const releaseControls = () => {
    for (const axis of ['x','z']) {
      if (!held[axis]) continue;
      held[axis] = false;
      game?.hold(axis, false);
    }
  };
  const stopLoop = () => {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = null; lastTime = null;
    scene?.cancelOrbit?.();
    releaseControls();
  };
  const updateTimer = (snapshot) => {
    const time = Math.max(0, snapshot.timeLeft ?? 10);
    const value = time.toFixed(1);
    if (timer.textContent !== value) timer.textContent = value;
    timer.parentElement.classList.toggle('is-urgent',time > 0 && time <= 3);
  };
  const animate = (time) => {
    frame = null;
    if (!dialog.open || document.hidden || suspended || contextLost || !game || !scene) { lastTime=null; return; }
    const dt = lastTime === null ? 0 : Math.max(0,(time-lastTime)/1000);
    lastTime=time;
    game.step(dt);
    const snapshot=game.getSnapshot();
    updateTimer(snapshot);
    scene.render(snapshot,time/1000,reduced.matches);
    frame=requestAnimationFrame(animate);
  };
  const startLoop = () => {
    if (frame === null && dialog.open && !document.hidden && !suspended && !contextLost && game && scene) frame=requestAnimationFrame(animate);
  };
  const ensureGame = () => {
    if (loading) return loading;
    loading = (async () => {
      if (!window.LymiaUFOVendor) await loadScript(loader.dataset.ufoVendor);
      await window.LymiaUFOVendor.init();
      if (!window.LymiaUFOPhysics) await loadScript(loader.dataset.ufoPhysics);
      if (!window.LymiaUFOScene) await loadScript(loader.dataset.ufoScene);
      if (!window.LymiaUFOArt) await loadScript(loader.dataset.ufoArt);
      if (!scene) scene=window.LymiaUFOScene.create(window.LymiaUFOVendor.THREE,canvas,{
        onContextLost() { contextLost=true;stopLoop();enableControls();setStatus('La vue 3D a été suspendue. Restauration en cours…'); },
        onContextRestored() { contextLost=false;enableControls();setStatus();startLoop(); },
      });
      if (!game) game=window.LymiaUFOPhysics.create(window.LymiaUFOVendor.RAPIER,{
        onPhase:setPhase,
        onWin(kind) {
          if (!(kind in names)) return;
          collection[kind]=Math.min(9999,collection[kind]+1);
          try {localStorage.setItem(collectionKey,JSON.stringify(collection));} catch (_) { /* Optional persistence. */ }
          showCollection(); result.textContent=`${names[kind]} rejoint ta collection !`;result.hidden=false;
        },
      });
      dialog.querySelectorAll('[data-ufo-mini]').forEach((mini)=>{
        if (scene.drawMini?.(mini, mini.dataset.ufoMini)) return;
        const ctx=mini.getContext('2d');if(!ctx)return;
        ctx.clearRect(0,0,mini.width,mini.height);
        window.LymiaUFOArt.prize(ctx,mini.dataset.ufoMini,mini.width/2,mini.height/2,23);
      });
      setPhase(game.getSnapshot().phase);enableControls();
      if (!contextLost) setStatus();
      scene.resize();scene.render(game.getSnapshot(),0,reduced.matches);updateTimer(game.getSnapshot());
      return game;
    })().catch((error)=>{loading=null;throw error;});
    return loading;
  };

  // Same Bézier silhouette and scale as the ambient rain, with a faint glow.
  const petalArt=petal.querySelector('[data-ufo-petal-art]');
  const petalContext=petalArt?.getContext('2d');
  if(petalContext){
    const c=petalContext;c.translate(20,20);c.scale(6.5,6.5);c.fillStyle='#eaa2b6';
    c.globalAlpha=.78;c.shadowColor='#e8ce91';c.shadowBlur=3;
    c.beginPath();c.moveTo(0,-.62);c.bezierCurveTo(-.7,-1.2,-1.05,-.15,0,1.15);
    c.bezierCurveTo(1.05,-.15,.7,-1.2,0,-.62);c.closePath();c.fill();
  }
  const motionPaused = () => reduced.matches || document.body.getAttribute('data-lj-motion-state') === 'paused';
  const cancelPetalFrame = () => {if(petalFrame!==null)cancelAnimationFrame(petalFrame);petalFrame=null;petalTime=null;};
  const hidePetal = () => {petal.hidden=true;petalState=null;petalHovered=false;cancelPetalFrame();};
  const placePetal = () => {
    if(!petalState)return;
    petal.style.setProperty('--ufo-petal-x',`${petalState.x}px`);
    petal.style.setProperty('--ufo-petal-y',`${petalState.y}px`);
    petal.style.setProperty('--ufo-petal-angle',`${petalState.angle}rad`);
  };
  const tickPetal = (time) => {
    petalFrame=null;
    if(!petalState || petal.hidden || document.hidden || suspended || dialog.open){petalTime=null;return;}
    const dt=petalTime===null?0:Math.min((time-petalTime)/1000,.05);petalTime=time;
    if(!motionPaused()&&!petalHovered&&document.activeElement!==petal){
      petalState.phase+=dt*.65;petalState.y+=dt*petalState.speed;
      petalState.x+=dt*(4+Math.sin(petalState.phase)*10);petalState.angle+=dt*.34;
      if(petalState.y>innerHeight+24){hidePetal();return;}
      petalState.x=Math.max(18,Math.min(innerWidth-18,petalState.x));placePetal();
    }
    // Let storefront controls receive clicks while the petal crosses them.
    petal.style.pointerEvents='none';
    const underneath=document.elementFromPoint(petalState.x,petalState.y);
    const blocked=!!underneath?.closest('a,button,input,textarea,select,summary,[role="button"],.product-card-wrapper,dialog');
    petal.style.pointerEvents=blocked?'none':'auto';
    petalFrame=requestAnimationFrame(tickPetal);
  };
  const startPetal = () => {if(petalState&&petalFrame===null&&!document.hidden&&!suspended&&!dialog.open)petalFrame=requestAnimationFrame(tickPetal);};
  const spawnPetal = () => {
    if(dialog.open||document.hidden||suspended)return false;
    hidePetal();
    petalState={x:32+Math.random()*Math.max(1,innerWidth-64),y:motionPaused()?Math.max(100,innerHeight*.3):20,
      speed:18+Math.random()*8,angle:Math.random()*Math.PI*2,phase:Math.random()*6};
    petal.hidden=false;placePetal();nextPetal=65+Math.random()*55;startPetal();return true;
  };
  const open = async () => {
    if(dialog.open)return;
    returnFocus=document.activeElement;hidePetal();oldOverflow=document.documentElement.style.overflow;
    document.documentElement.style.overflow='hidden';document.body.setAttribute('data-lj-ufo-open','true');
    document.dispatchEvent(new Event('lymia:ufo:visibility'));dialog.showModal();
    setStatus(contextLost ? 'La vue 3D a été suspendue. Restauration en cours…' : game ? '' : 'La borne 3D se prépare…');enableControls();
    try {await ensureGame();if(dialog.open){scene.resize();startLoop();canvas.focus({preventScroll:true});}}
    catch (_) {setStatus('La borne 3D n’a pas pu se charger. Vérifie les fichiers du thème et WebGL, puis réessaie.');enableControls();}
  };
  const close=()=>{if(dialog.open)dialog.close();};
  dialog.addEventListener('close',()=>{
    stopLoop();document.documentElement.style.overflow=oldOverflow;document.body.removeAttribute('data-lj-ufo-open');
    document.dispatchEvent(new Event('lymia:ufo:visibility'));nextPetal=65+Math.random()*55;
    if(returnFocus===petal){spawnPetal();if(petalState){petalState.y=Math.max(90,innerHeight*.3);placePetal();}}
    if(returnFocus?.isConnected&&!returnFocus.hidden&&!returnFocus.disabled)returnFocus.focus({preventScroll:true});
  });
  $('[data-ufo-close]').addEventListener('click',close);
  petal.addEventListener('click',open);
  petal.addEventListener('pointerenter',()=>{petalHovered=true;});
  petal.addEventListener('pointerleave',()=>{petalHovered=false;});
  const startRound=()=>{if(game&&!contextLost&&phase==='idle')game.start();};
  const drop=()=>{if(game&&!contextLost&&phase==='ready-drop')game.drop();};
  $('[data-ufo-start]').addEventListener('click',startRound);
  $('[data-ufo-drop]').addEventListener('click',drop);
  $('[data-ufo-view-reset]').addEventListener('click',()=>{
    if(scene&&!contextLost)scene.resetView();
  });
  const holdAxis=(axis,pressed)=>{
    if(!game||contextLost||phase!==(axis==='x'?'aim-x':'aim-z'))return;
    if(held[axis]===pressed)return;
    held[axis]=pressed;
    $(axis==='x'?'[data-ufo-right]':'[data-ufo-back]').setAttribute('aria-pressed',String(pressed));
    game.hold(axis,pressed);
  };
  for(const [selector,axis] of [['[data-ufo-right]','x'],['[data-ufo-back]','z']]){
    const button=$(selector);
    button.addEventListener('pointerdown',event=>{
      if(event.button!==0||button.disabled)return;button.setPointerCapture(event.pointerId);holdAxis(axis,true);
    });
    for(const type of ['pointerup','pointercancel','lostpointercapture'])button.addEventListener(type,()=>holdAxis(axis,false));
    button.addEventListener('click',event=>{if(event.detail===0)holdAxis(axis,!held[axis]);});
  }
  dialog.addEventListener('keydown',event=>{
    if(contextLost)return;
    if(event.target===canvas&&scene&&!event.ctrlKey&&!event.altKey&&!event.metaKey){
      const orbitKeys={KeyJ:[-5,0],KeyL:[5,0],KeyI:[0,5],KeyK:[0,-5]};
      if(orbitKeys[event.code]){
        event.preventDefault();scene.orbitBy(...orbitKeys[event.code]);return;
      }
      if(event.code==='KeyR'){
        event.preventDefault();if(!event.repeat)scene.resetView();return;
      }
    }
    if(event.code==='ArrowRight'||event.code==='ArrowUp'){
      event.preventDefault();if(!event.repeat)holdAxis(event.code==='ArrowRight'?'x':'z',true);
    }else if(event.code==='ArrowLeft'||event.code==='ArrowDown'){event.preventDefault();}
    else if(event.code==='Space'&&event.target===canvas){
      event.preventDefault();if(event.repeat)return;
      if(phase==='idle')startRound();else if(phase==='ready-drop')drop();else if(phase==='aim-x'||phase==='aim-z')game?.lockAxis();
    }
  });
  dialog.addEventListener('keyup',event=>{
    if(event.code==='ArrowRight')holdAxis('x',false);
    if(event.code==='ArrowUp')holdAxis('z',false);
  });
  window.addEventListener('blur',()=>releaseControls());
  window.addEventListener('resize',()=>{if(petalState){petalState.x=Math.min(innerWidth-18,petalState.x);placePetal();}scene?.resize();});
  document.addEventListener('visibilitychange',()=>{if(document.hidden){stopLoop();cancelPetalFrame();}else{startLoop();startPetal();}});
  window.addEventListener('pagehide',()=>{suspended=true;stopLoop();cancelPetalFrame();});
  window.addEventListener('pageshow',()=>{suspended=false;startLoop();startPetal();});
  setInterval(()=>{
    if(document.hidden||suspended||dialog.open||document.querySelector('dialog[open],.menu-drawer-container[open],cart-drawer.active'))return;
    if(petal.hidden&&--nextPetal<=0)spawnPetal();
  },1000);
  window.LymiaUFO=Object.freeze({spawnPetal,open,close});
})();
